<template>
  <div class="bodys">
    <div class="head">
      <img src="../assets/images/logo.png" width="24">
      {{configData.site_name}}
      <span style="position: absolute;right: 10px;font-size: 16px;">{{uname.substr(-7)}}</span>
    </div>
    <div class="contentss">
      <div class="userInfo">
        <div class="market-mobile"></div>
        <div class="market-mobile2"></div>
        <div class="new-feature" style="margin-bottom: 20px">
          <div class="title">
            <i class="el-icon-s-finance" style="font-size: 20px;font-weight: 600" ></i>
            {{lang.coin}}
          </div>

          <div class="coin" >$ {{ userInfo.blc.toFixed(2)  }}</div>
          <div class="infos">
            <div class="info">
              <div class="info-title">{{lang.todayBenefit}}</div>
              <div class="info-content" >$ {{ (userInfo.gainToday + userInfo.invtToday).toFixed(2)  }}</div>
            </div>
            <div class="info">
              <div class="info-title">{{ lang.AITrading }}</div>
              <div class="info-content" >$ {{ userInfo.aiAmt.toFixed(2) }}</div>
            </div>
            <div class="info">
              <div class="info-title">{{ lang.hbl }}</div>
              <div class="info-content" v-if="userInfo.gainHbl == 0">$ 0.00</div>
              <div class="info-content" v-else> {{ userInfo.gainHbl }} %</div>
            </div>
          </div>
        </div>
      </div>
      <div class="membernews">
        <div class="hot">
          <div class="item" v-for="(item,index) in coinList.slice(0,3)" @click="goGoods(item.title)">
            <div class="name">
              <span style="font-size: 14px">{{item.title}}/USDT</span>
            </div>
            <div class="dianwei">
              <span :class="[item.price - item.priceOpen > 0 ? 'green' : 'red']" style="font-size: 18px;margin-right: 5px;">{{ item.incPct }}% </span>
              <div class="number-info-arrow">
                <img src="../assets/images/up_arrow.svg" v-if="item.price - item.priceOpen > 0">
                <img src="../assets/images/down_arrow.svg" v-else>
              </div>

            </div>
          </div>
        </div>
        <div id="newsBox">
          <div style="padding: 7px 1px;display: flex;justify-content: space-between;" @click="toPath('Quotation')">
            <span>{{lang.sc}}</span>
            <span style="font-size: 12px;opacity: 0.5;">{{lang.ckxq}}</span>
          </div>
          <ul class="newsList">
            <li v-for="(item,index) in coinList.slice(3,20)" :key="index" @click="goGoods(item.title)">
              <div class="token-logo" >
                <img :src="apiSer+item.img" alt="">{{item.title}}/USDT
              </div>
              <div :class="[item.incPct > 0 ? 'red' : 'green']">
                <SimpleLineChart :message="item.history" :color="item.incPct < 0 ? '#ce7735' : '#c2e22a'" />
              </div>
              <div  class='price'>
                <span >{{ item.price }}</span>
                <span :class="[item.incPct > 0 ? 'green' : 'red']">{{ item.incPct }}%</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
<!--      <div class="new-feature2">-->
<!--        <div class="img"><img src="../assets/images/saleCoin.svg" ></div>-->
<!--        <div class="strategy-text">即将推出</div>-->
<!--        <div class="strategy-text1">新币预售</div>-->
<!--        <div class="strategy-text">踏上数字财富之旅</div>-->
<!--        <div class="button" >-->
<!--          <el-button type="danger" round>{{ lang.confirm }}</el-button>-->
<!--        </div>-->
<!--      </div>-->
      <div class="new-feature2">
        <div class="img"><img src="../assets/images/trading.svg" ></div>
        <div class="strategy-text">{{ lang.czjd }}</div>
        <div class="strategy-text1">{{ lang.AITrading }}</div>
        <div class="strategy-text">{{ lang.aqwdjd }}</div>
        <div class="button" >
          <el-button type="danger" round>{{ lang.createTP }}</el-button>
        </div>
      </div>
    </div>
    <Bottom />
  </div>
</template>
<script type="text/javascript">
import {mapState} from 'vuex';
import * as echarts from 'echarts';
import SimpleLineChart from '../components/commons/SimpleLineChart.vue';
import { CONF,API_SERVER } from '@/assets/js/config'
import axios from 'axios'
import router from "../router";
import store from "../store";
export default {
  data() {
    return {
      apiSer: API_SERVER,
      uname:sessionStorage.getItem('userToken'),
      configData:this.$store.state.configData,
      input:'',
      xregion:'',
      amt:0,
      aiRatioId:'',
      userInfo :{
        "blc":0,
      },
      aiRatioInfo :{},
      activatItem :{},
      coinList :[],

      socket: null,
      messages: [],
    }
  },
  computed: {
    ...mapState(['lang']),
  },
  created() {

    this.getUserInfo()
    this.getAiRatio()
    clearInterval(this.timer)
    this.timer = setInterval(()=>{
      this.getCoin()
    },2e3)
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
    this.socket.close();
    this.socket = null;
  },

  mounted() {
    this.getss()
  },
  methods: {
    getss(){
      var chartDom = document.getElementById('echarts');
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          show:false
        },
        yAxis: {
          type: 'value',
          show:false
        },
        series: [
          {
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: 'line',
            smooth: true
          }
        ]
      };
      option && myChart.setOption(option);
    },


    getUserInfo(){
      this.$xhrGet('/member/center').then(res => {
        if (res.err == 0) {
          this.userInfo = res.data
        }
      })
    },
    getAiRatio(){
      this.$xhrGet('/product/aiRatio').then(res => {
        if (res.err == 0) {
          this.aiRatioInfo = res.data
          for (var i in this.aiRatioInfo){
            this.activatItem = this.aiRatioInfo[i]
            this.aiRatioId =this.aiRatioInfo[i].id
            break
          }
        }
      })
    },
    getCoin(){
      this.$xhrGet('/ws').then(res => {
        if (res.err == 0) {
          this.coinList = res.data
        }
      })
    },
    // getCoin(){
    //   var url = this.apiSer.replace('http','ws')
    //   this.socket = new WebSocket(url + '/ws');
    //   this.socket.onmessage = (event) => {
    //     // Parse JSON message
    //     const message = JSON.parse(event.data);
    //     this.coinList = message.data.data
    //   };
    // },
    goGoods(type){
      // this.$router.push('')
      window.location.href = '/#/Goods?coinName=' + type
      // this.$router.push({
      //   name:'Goods',
      //   query:{
      //     coinName:type
      //   }
      // })
    },
    toPath(name){
      this.$router.push(name)
    },
  }
}
</script>
<style>
.bodys{
  height: 100%;
  background: #000;
  color: #fff;
}
.head{
  padding: 15px;
  font-size: 20px;
  font-weight: 600;
}
.contentss{
  padding: 0.4rem;
  height: 87%;
  background: #000;
  width: 100%;
  margin: auto;
  overflow: auto;
  position: relative;
}
.contentss .userInfo{
  overflow: hidden;
  position: relative;
}
.market-mobile {
  background: #d8d8d8;
  mix-blend-mode: normal;
  opacity: .08;
  transform: rotate(326deg);
  width: 130px;
  height: 236px;
  position: absolute;
  right: -30px;
  top: -100px;
  margin-top: 50px;
}
.market-mobile2 {
  background: #d8d8d8;
  mix-blend-mode: normal;
  opacity: .08;
  transform: rotate(326deg);
  width: 130px;
  height: 236px;
  position: absolute;
  right: -70px;
  top: -100px;
  margin-top: 50px;
}
.new-feature{
  padding: 15px;
  background: #1a1a1a;
  border-radius: 20px;
}
.new-feature .title{
  font-size: 12px;
}
.new-feature .coin{
  font-size: 32px;
  font-weight: 600;
  padding: 10px 0px;
  border-bottom: 1px solid hsla(0, 0%, 100%, .07);
}
.infos{
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}
.infos .info-title{
  font-weight: 500;
  font-size: 14px;
  color: #fff;
  opacity: .3;
}
.infos .info-content{
  font-weight: 700;
  font-size: 16px;
  font-family: DIN Alternate;
  margin-top: 8px;
}


.membernews {
  margin-bottom: 20px;
}
.membernews .title {
  color: #333;
  font-size: 16px;
  font-weight: bold;
  line-height: 30px;
  margin: 10px 0;
}

.membernews #newsBox {
  height: calc(100% - 50px);
  overflow: hidden;
  background: #1a1a1a;
  border-radius: 5px;
  padding: 10px ;
}
.membernews #newsBox .newsList {
}
.membernews #newsBox .newsList li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  margin-bottom: 10px;
}
.membernews #newsBox .newsList li .token-logo{
  flex: 0 0 40%;
  text-align: left
}
.membernews #newsBox .newsList li .price{
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.membernews #newsBox .newsList li:first-child {
  color: #fff;
}
.membernews #newsBox .newsList li:last-child {
  border: none;
}
.membernews #newsBox .newsList li div {
  flex: 0 0 25%;
  text-align: center;
}
.membernews #newsBox .newsList li div.red {
  color: #ce7735;
}
.membernews #newsBox .newsList li div .green {
  color: #c2e22a;
}
.membernews #newsBox .newsList li .token-logo{
  font-size: 13px;
}
.membernews #newsBox .newsList li .token-logo img{
  width: 18px;
  position: relative;
  top: 4px;
  margin: 0 5px;
}
.membernews .hot{
  display: flex;
  margin-bottom: 20px;
  overflow: auto;
  justify-content: space-between;
}
.membernews .hot .item{
  border-radius: 0.26667rem;
  box-shadow: 0.03333rem 0.03333rem 0.13333rem #0000003a;
  padding: 8px;
  background: #1a1a1a;
  font-size: 10px;
  flex: 0 0 30%;
  margin-right: 8px;
}
.membernews .hot .item .name{
  display: flex;
  align-items: center;
}
.membernews .hot .item div{
  margin-bottom: 3px;
}
.membernews .hot .item .name img{
  margin-right: 5px;
}
.membernews .hot .item .dianwei{
  display: flex;
  align-items: flex-start;
  margin-top: 20px;
}
.membernews .hot .item .dianwei .number-info-arrow{
  width: 20px;
  height: 20px;
  border-radius:20px;
  background: hsla(0, 0%, 100%, .13);
  line-height: 20px;
  text-align: center;
}
.membernews .hot .item .zhangfu{
  font-size: 9px;
}
.membernews .hot .item .bottom{
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  font-size: 8px;
}
.new-feature2{
  padding: 25px 15px;
  background: #1a1a1a;
  border-radius: 20px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.strategy-text{
  font-weight: 500;
  font-size: 14px;
  color: hsla(0, 0%, 100%, .3);
  margin-top: 7px;
}
.strategy-text1{
  margin-top: 7px;
  font-weight: 500;
  font-size: 22px;
  color: #fff;
}
.new-feature2 .button{
  width: 100%;
}


.red{
  color: #ce7735;
}
.green{
  color: #c2e22a;
}
.el-button.is-round {
  border-radius: 13px;
  width: 100%;
}
.el-button--danger,.el-button--danger:focus, .el-button--danger:hover {
  color: #000;
  background: #c0dd2b;

  border-color:#c0dd2b;
}

</style>